<template>
    <div>
        Terminos
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/auth/docs/termsConditions.vue?26c35aed